import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UzurvPipesModule } from '@uzurv/core';
import { MaterialModule } from '../../../app/material.module';
import { DriverFareCalculationHistoryDailogComponent } from './driver-fare-calculation-history-dialog.component';

@NgModule({
  imports: [CommonModule, MaterialModule, UzurvPipesModule],
  exports: [DriverFareCalculationHistoryDailogComponent],
  declarations: [DriverFareCalculationHistoryDailogComponent]
})
export class DriverFareCalculationHistoryDailogModule {}
